export class CurRoute {
    public static isDevelopmentEnv() : boolean {
        return window.location.host.startsWith('localhost:4200');
    }

    public static isTestEnv() : boolean {
        return window.location.host.startsWith('str.devtest.gf.aws.scania.com');
    }

    public static isProdEnv() : boolean {
        return window.location.host.startsWith('boka.scania.com');
    }
}


